import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Fce } from '../../fce';
import { DropdownPosition, NgSelectComponent } from '@ng-select/ng-select';
@Component({
  selector: 's-select',
  templateUrl: './s-select.component.html',
  styleUrls: ['./s-select.component.scss']
})
export class SSelectComponent implements OnInit {
  @ViewChild('select', { static: false }) select: NgSelectComponent;

  @Input() items: any[] = [];
  @Input() model: any;
  @Input() bindValue: string;
  @Input() bindLabel: string;
  @Input() name: string;
  @Input() customClass: string = "";
  @Input() dropdownPosition: DropdownPosition = "auto";
  @Input() addTag: boolean | ((term: string) => any) = false;
  @Input() disabled: boolean = false;
  @Input() appendTo: string = null;
  @Input() loading: boolean = false;
  @Input() multiple: boolean = false;
  @Input() required: boolean = false;
  @Input() clearable: boolean = true;
  @Input() searchable: boolean = true;
  @Input() placeholder: string;
  @Input() minW: boolean = true;
  @Input() searchFn: (term: string, item: any) => boolean
  @Input() customOption: (item: any) => string
  @Input() customLabel: (item: any) => string
  @Input() translateAppendix: string = null
  @Input() tabIndex: number = null;
  @Input() groupBy: string = null;
  @Input() compareWith: (a: any, b: any) => boolean = null;

  @Output() blur = new EventEmitter()
  @Output() change = new EventEmitter()
  @Output() search = new EventEmitter()
  @Output() modelChange = new EventEmitter()

  showTranslateAppendix: boolean = false

  constructor() {
  }

  ngOnInit(): void {
    if (this.customOption && !this.customLabel)
      this.customLabel = this.customOption
    if (!Fce.empty(this.translateAppendix)) {
      this.showTranslateAppendix = true
      if (this.translateAppendix == ".")
        this.translateAppendix = ""
    }
  }

  isEmpty() {
    return Fce.empty(this.model)
  }

  getItemWithAppendix(item) {
    return `${this.translateAppendix}${this.bindLabel ? item[this.bindLabel] : item}`
  }
  
  focus() {
    if (this.select) {
      this.select.focus()
    }
  }
}
